// WAENN — Guardados (Wishlist)
// ============================================================================
// Motor completo de "Guardados": persistencia en localStorage (funciona
// igual para invitados y para clientes con sesion iniciada, dentro del
// mismo navegador), sincronizacion instantanea de TODOS los iconos de
// guardar del sitio (grid, PDP, drawer del header, carrusel Comunidad
// WAENN) via un evento custom, y el propio drawer flotante "saved-drawer"
// con el mismo lenguaje visual que el carrito.
//
// Nota de alcance: Shopify no ofrece ninguna API va desde el tema (JS de
// cliente) para escribir metafields de cliente ni sincronizar wishlists
// entre dispositivos sin un backend/app propio -- eso exigiria una app o
// servidor adicional con acceso a la Admin API, que queda fuera del
// alcance de un tema. Esta implementacion persiste en localStorage, que ya
// cumple "no perder los guardados mientras se navega": se mantiene entre
// paginas y recargas en el mismo navegador, tanto para invitados como para
// clientes logueados.
//
// Tipos de item guardados:
//  - Producto individual (tarjetas de producto, PDP): item.productId es el
//    id real del producto de Shopify.
//  - "Look" del carrusel Comunidad WAENN (ver assets/waenn-community-
//    carousel.js): item.type === 'look', item.productId = 'look-' +
//    block.id (prefijo para no colisionar nunca con un id de producto real,
//    que en Shopify siempre es puramente numerico). Lleva la foto + @usuario
//    + hasta 3 prendas etiquetadas, en vez de una sola variante -- por eso
//    no reutiliza el shape de un item de producto normal.
// ============================================================================

(function () {
  'use strict';

  var STORAGE_KEY = 'waenn_wishlist_v1';
  var CHANGE_EVENT = 'waenn:wishlist:change';

  // -------------------------------------------------------------------------
  // Almacenamiento
  // -------------------------------------------------------------------------

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : [];
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (err) {
      // localStorage no disponible (modo privado, cuota llena, etc.) -- no
      // rompemos la interaccion, simplemente no persiste.
    }
    emitChange(items);
  }

  function emitChange(items) {
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { items: items } }));
  }

  function isSaved(productId) {
    if (!productId) return false;
    productId = String(productId);
    return readAll().some(function (item) {
      return String(item.productId) === productId;
    });
  }

  function findItem(productId) {
    productId = String(productId);
    var all = readAll();
    for (var i = 0; i < all.length; i++) {
      if (String(all[i].productId) === productId) return all[i];
    }
    return null;
  }

  function add(item) {
    if (!item || !item.productId) return;
    var pid = String(item.productId);
    var items = readAll().filter(function (existing) {
      return String(existing.productId) !== pid;
    });
    items.unshift(item);
    writeAll(items);
  }

  function remove(productId) {
    if (!productId) return;
    var pid = String(productId);
    var items = readAll().filter(function (existing) {
      return String(existing.productId) !== pid;
    });
    writeAll(items);
  }

  function toggle(item) {
    if (!item || !item.productId) return false;
    if (isSaved(item.productId)) {
      remove(item.productId);
      return false;
    }
    add(item);
    return true;
  }

  window.WaennWishlist = {
    STORAGE_KEY: STORAGE_KEY,
    CHANGE_EVENT: CHANGE_EVENT,
    getAll: readAll,
    isSaved: isSaved,
    findItem: findItem,
    add: add,
    remove: remove,
    toggle: toggle,
  };

  // -------------------------------------------------------------------------
  // Iconos de guardar (tarjetas de producto + boton del PDP): click, estado
  // visual, animacion y sincronizacion.
  // -------------------------------------------------------------------------

  function collectDataFromButton(btn) {
    var data = {
      productId: btn.getAttribute('data-product-id') || '',
      variantId: btn.getAttribute('data-variant-id') || '',
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      url: btn.getAttribute('data-url') || '',
      color: btn.getAttribute('data-color') || '',
      size: btn.getAttribute('data-size') || '',
    };

    // En el PDP la seleccion de talla/color puede haber cambiado desde que
    // se pinto la pagina (sin recarga). Leemos el estado ACTUAL del
    // formulario en el momento del click para que lo guardado refleje la
    // variante realmente seleccionada, en vez del snapshot inicial.
    var form = btn.closest('product-form, .waenn-pdp__form, form');
    if (form) {
      var variantInput = form.querySelector('.waenn-pdp__variant-id, input[name="id"]');
      if (variantInput && variantInput.value) data.variantId = variantInput.value;

      var checkedRadios = form.querySelectorAll('input[type="radio"][data-option-index]:checked');
      checkedRadios.forEach(function (radio) {
        var fieldset = radio.closest('fieldset');
        var legend = fieldset ? fieldset.querySelector('legend') : null;
        var label = legend ? legend.textContent.trim().toLowerCase() : '';
        if (label.indexOf('talla') === 0 || label.indexOf('size') === 0) {
          data.size = radio.value;
        } else {
          data.color = radio.value;
        }
      });
    }

    return data;
  }

  function syncButtons() {
    var buttons = document.querySelectorAll('[data-waenn-save-btn]');
    buttons.forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      if (!pid) return;
      var saved = isSaved(pid);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-label', saved ? 'Quitar de guardados' : 'Guardar');
    });
  }

  function animateButton(btn) {
    btn.classList.remove('is-bouncing');
    // Forzar reflow para poder reiniciar la animacion en clicks consecutivos.
    void btn.offsetWidth;
    btn.classList.add('is-bouncing');
    window.setTimeout(function () {
      btn.classList.remove('is-bouncing');
    }, 420);
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-waenn-save-btn]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    var data = collectDataFromButton(btn);
    if (!data.productId) return;
    toggle(data);
    animateButton(btn);
  });

  window.addEventListener(CHANGE_EVENT, syncButtons);
  document.addEventListener('DOMContentLoaded', syncButtons);
  if (document.readyState !== 'loading') syncButtons();
  // Dawn vuelve a pintar secciones (filtros, ordenar, paginacion) via fetch
  // + innerHTML; cuando eso pasa hay que re-sincronizar los iconos nuevos.
  document.addEventListener('shopify:section:load', syncButtons);

  // -------------------------------------------------------------------------
  // Icono "Guardados" del header y del menu movil: solo abren el drawer, no
  // guardan nada ellos mismos (no llevan data-product-id). El icono del
  // header usa el id #saved-items-icon-bubble; el enlace nuevo dentro del
  // menu movil (snippets/header-drawer.liquid) usa el atributo
  // data-waenn-open-saved en su lugar, porque no se puede repetir el mismo
  // id en dos elementos del DOM (seria HTML invalido).
  // -------------------------------------------------------------------------

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('#saved-items-icon-bubble, [data-waenn-open-saved]');
    if (!trigger) return;
    evt.preventDefault();
    var drawer = document.querySelector('saved-drawer');
    if (drawer) drawer.open();

    // Si el trigger viene de dentro del menu movil (hamburguesa), cerramos
    // ese menu para que no quede un drawer abierto detras de otro.
    var headerMenuDetails = document.getElementById('Details-menu-drawer-container');
    if (headerMenuDetails && headerMenuDetails.hasAttribute('open')) {
      headerMenuDetails.removeAttribute('open');
    }
  });

  // -------------------------------------------------------------------------
  // Drawer de Guardados
  // -------------------------------------------------------------------------

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function continueShoppingUrl() {
    return (window.routes && window.routes.all_products_url) || '/collections/all';
  }

  function buildEmptyState() {
    return (
      '<div class="waenn-saved-empty">' +
        '<p class="waenn-saved-empty__title">No saved items yet.</p>' +
        '<p class="waenn-saved-empty__subtitle">Save products you love to find them later.</p>' +
        '<a class="waenn-saved-empty__cta" href="' + escapeHtml(continueShoppingUrl()) + '">Continue Shopping</a>' +
      '</div>'
    );
  }

  function buildProductRow(item) {
    var metaParts = [];
    if (item.color) metaParts.push(escapeHtml(item.color));
    if (item.size) metaParts.push(escapeHtml(item.size));
    var metaHtml = metaParts.length
      ? '<p class="waenn-saved-item__meta">' + metaParts.join(' &middot; ') + '</p>'
      : '';

    var mediaHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="84" height="105">'
      : '<span class="waenn-saved-item__placeholder" aria-hidden="true"></span>';

    var canAddToCart = !!item.variantId;

    return (
      '<div class="waenn-saved-item" data-saved-item data-product-id="' + escapeHtml(item.productId) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="waenn-saved-item__media">' + mediaHtml + '</a>' +
        '<div class="waenn-saved-item__body">' +
          '<a href="' + escapeHtml(item.url) + '" class="waenn-saved-item__title">' + escapeHtml(item.title) + '</a>' +
          metaHtml +
          '<p class="waenn-saved-item__price">' + escapeHtml(item.price) + '</p>' +
          '<div class="waenn-saved-item__actions">' +
            '<button type="button" class="waenn-saved-item__add" data-saved-add-to-cart' +
              (canAddToCart ? ' data-variant-id="' + escapeHtml(item.variantId) + '"' : ' disabled') +
            '>Añadir al carrito</button>' +
            '<button type="button" class="waenn-saved-item__remove" data-saved-remove data-product-id="' + escapeHtml(item.productId) + '">Quitar</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  // "Look" guardado desde el carrusel Comunidad WAENN: una foto + @usuario +
  // hasta 3 prendas etiquetadas (en vez de una sola variante), asi que se
  // pinta como su propia tarjeta dentro del mismo drawer de Guardados.
  function buildLookRow(item) {
    var products = item.products || [];
    var productsHtml = products.length
      ? '<div class="waenn-saved-look__products">' +
          products.map(function (product) {
            var thumb = product.image
              ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="36" height="45">'
              : '';
            return (
              '<a class="waenn-saved-look__product" href="' + escapeHtml(product.url) + '">' +
                thumb +
                '<span class="waenn-saved-look__product-info">' +
                  '<span class="waenn-saved-look__product-title">' + escapeHtml(product.title) + '</span>' +
                  '<span class="waenn-saved-look__product-price">' + escapeHtml(product.price) + '</span>' +
                '</span>' +
              '</a>'
            );
          }).join('') +
        '</div>'
      : '';

    var mediaHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.handle) + '" loading="lazy" width="84" height="105">'
      : '<span class="waenn-saved-item__placeholder" aria-hidden="true"></span>';

    return (
      '<div class="waenn-saved-item waenn-saved-item--look" data-saved-item data-product-id="' + escapeHtml(item.productId) + '">' +
        '<span class="waenn-saved-item__media">' + mediaHtml + '</span>' +
        '<div class="waenn-saved-item__body">' +
          '<p class="waenn-saved-item__title waenn-saved-look__handle">' + escapeHtml(item.handle || 'Look guardado') + '</p>' +
          '<p class="waenn-saved-item__meta">Look de Comunidad WAENN</p>' +
          productsHtml +
          '<div class="waenn-saved-item__actions">' +
            '<button type="button" class="waenn-saved-item__remove" data-saved-remove data-product-id="' + escapeHtml(item.productId) + '">Quitar</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function buildItemRow(item) {
    return item.type === 'look' ? buildLookRow(item) : buildProductRow(item);
  }

  function renderSavedDrawer() {
    var list = document.getElementById('WaennSavedList');
    if (!list) return;
    var items = readAll();
    if (!items.length) {
      list.innerHTML = buildEmptyState();
      return;
    }
    list.innerHTML = '<div class="waenn-saved-list">' + items.map(buildItemRow).join('') + '</div>';
  }

  window.addEventListener(CHANGE_EVENT, renderSavedDrawer);
  document.addEventListener('DOMContentLoaded', renderSavedDrawer);

  document.addEventListener('click', function (evt) {
    var removeBtn = evt.target.closest('[data-saved-remove]');
    if (removeBtn) {
      remove(removeBtn.getAttribute('data-product-id'));
      return;
    }

    var addBtn = evt.target.closest('[data-saved-add-to-cart]');
    if (addBtn) {
      if (addBtn.disabled) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var cartDrawerEl = document.querySelector('cart-drawer');

      // IMPORTANTE: cart-drawer.js#renderContents() espera TODAS las
      // secciones que su propio getSectionsToRender() declara (cart-drawer
      // + cart-icon-bubble). Si solo pedimos 'cart-drawer', parsedState.
      // sections['cart-icon-bubble'] es undefined y renderContents lanza un
      // TypeError al intentar leer innerHTML de un nodo nulo (rompiendo el
      // resto de nuestra logica: no se cierra el drawer de Guardados ni se
      // abre el del carrito). Pedimos exactamente las mismas secciones que
      // usa el <product-form> nativo de Dawn para este mismo flujo.
      var sectionsToRequest =
        cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function'
          ? cartDrawerEl.getSectionsToRender().map(function (section) {
              return section.id;
            })
          : ['cart-drawer', 'cart-icon-bubble'];

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionsToRequest,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');

          if (data && data.status) {
            // Shopify devuelve status/description en errores (p.ej. sin stock).
            addBtn.classList.add('is-error');
            window.setTimeout(function () {
              addBtn.classList.remove('is-error');
            }, 1600);
            return;
          }

          if (cartDrawerEl && data && data.sections && typeof cartDrawerEl.renderContents === 'function') {
            cartDrawerEl.renderContents(data);
          }

          var savedDrawerEl = document.querySelector('saved-drawer');
          if (savedDrawerEl && typeof savedDrawerEl.close === 'function') savedDrawerEl.close();
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        });
    }
  });

  // -------------------------------------------------------------------------
  // Custom element <saved-drawer>: misma logica de apertura/cierre que Dawn
  // usa para <cart-drawer> (assets/cart-drawer.js), simplificada porque el
  // contenido se pinta en JS en vez de venir del servidor.
  // -------------------------------------------------------------------------

  function anyOtherDrawerActive(exceptEl) {
    var drawers = document.querySelectorAll('.drawer.active');
    for (var i = 0; i < drawers.length; i++) {
      if (drawers[i] !== exceptEl) return true;
    }
    return false;
  }

  function defineSavedDrawer() {
    if (customElements.get('saved-drawer')) return;

    class SavedDrawer extends HTMLElement {
      constructor() {
        super();
        var overlay = this.querySelector('.cart-drawer__overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.addEventListener('keyup', function (evt) {
          if (evt.code === 'Escape') this.close();
        }.bind(this));
      }

      open() {
        if (this.classList.contains('active')) return;

        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && cartDrawerEl.classList.contains('active') && typeof cartDrawerEl.close === 'function') {
          cartDrawerEl.close();
        }

        renderSavedDrawer();

        window.setTimeout(function () {
          this.classList.add('animate', 'active');
        }.bind(this));

        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        if (!anyOtherDrawerActive(this)) {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }

    customElements.define('saved-drawer', SavedDrawer);
  }

  defineSavedDrawer();
})();
